import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7dabeadd")

_pushScopeId("data-v-7dabeadd")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "名前変更", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("名前変更")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_edit_box = _resolveComponent("icon-edit-box")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, null, {
    default: _withId(() => [
      _hoisted_1,
      _createVNode(_component_icon_edit_box, {
        class: "login-edit-box",
        icon: "user-circle",
        title: "名前",
        placeholder: "名前(先生・スタッフの表示名称)",
        modelValue: _ctx.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
        validation: _ctx.nameError
      }, null, 8, ["modelValue", "validation"]),
      _createVNode(_component_normal_button, {
        class: "submit-button",
        state: "normal",
        disabled: _ctx.requesting,
        onClick: _ctx.onSubmitName
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }))
})